/* eslint-disable react-hooks/exhaustive-deps */
import {
  EllipsisOutlined,
  QuestionCircleOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Col, Modal, Popover, Row, Typography } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { VideoApi } from "../../api/backend/video";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import FooterPage from "../../component/footer/footerPage";
import { COMMON_CONSTANT, KEY, lang } from "../../constants/common.const";
import { getQuerySearch, handleCatchError, showMessage } from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classText from "../../models/control/text";
import { convertGoogleDriveLinkToEmbed, safeGoBack } from "../../utils/helper";
import VideoAction from "./videoAction";
import VideoComments from "./videoComment";
import VideoDescription from "./videoDescription";
import "./view.scss";
import { VideoFrame } from "./videoFrame";
const { Text, Title } = Typography;
function ViewVideo() {
    const objSearch = getQuerySearch();
    const isFrom = objSearch.from;
    const isHideButtonBack = isFrom  && isFrom === "checklist"
  
  let [txtTitle, settxtTitle] = useState(new classText()); //Required
  const [txtDescription, setTxtDescription] = useState(new classText());
  let [sender, setSender] = useState(new classText()); //Required
  const [videoUrl, setVideoUrl] = useState(new classText());
  const [listCate, setListCate] = useState(new classDdl());
  const [tags, setTags] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState([]);
  const { id } = useParams();
  let [showLoading, setShowLoading] = useState(false);
  const [updateTime, setUpdateTime] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [listMachine, setListMachine] = useState([]);
  const [isVideoPlayList,setisVideoPlayList] = useState(true)
  const [avatarUrl,setAvatarUrl] = useState("")

  const [isDirty, setIsDirty] = useState(false);
  const history = useHistory();
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  const showDetail = async (data) => {
    settxtTitle({ ...txtTitle, value: data.title });
    setSender({ ...sender, value: data.displayName || data.updateId });
    setTxtDescription({ ...txtDescription, value: data.videoExplanation });
    setVideoUrl({ ...videoUrl, value: data.videoUrl });
    setTags(data.tagLists);
    if (data.categoryID !== null && data.categoryID !== undefined) {
      setListCate({
        ...listCate,
        value: data.categoryID,
        label: data.categoryName,
      });
    }
    setUpdateTime(moment(data.updateDatetime).format("YYYY/MM/DD HH:mm:ss"));

    setSelectedOffice(data.videoOfficeDTOs.map((i) => i.siteOfficeMasterName));
    setIsEdit(data.isEdit);
    setIsDelete(data.isDelete);
    setisVideoPlayList(data.isVideoPlayList)
    setListMachine(
      data.manualVideoItemDTOs.map((i) => i.machineForSiteOfficeName)
    );
    setAvatarUrl(data.avatarUrl)
  };
  const getDetailData = async () => {
    try {
      openLoadingSpinner();
      const res = await VideoApi.getManualVideoById(id);
      await showDetail(res.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        history.push("/VideoManagement");
      } else {
        handleCatchError(error);
      }
    } finally {
      closeLoadingSpinner();
    }
  };
  useEffect(() => {
    if (id) {
      getDetailData();
    }
  }, [id]);

  const handleback = () => {
    if (isDirty) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: () =>  safeGoBack(history,"/VideoManagement")
      });
    } else {
      safeGoBack(history,"/VideoManagement")
    }
  };
  return (
    <div
      style={{
        background: "#fff",
      }}
      className="des-content"
    >
      <TitlePage name={"動画情報"} />
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <div
            style={{
              // position: "relative",
              width: "100%",
              // paddingTop: "56.25%",
              // overflow: "hidden",
            }}
          >
            <iframe
              style={{
                borderRadius: 10,
                border: "none",
              }}
              width="100%"
              height="520"
              src={convertGoogleDriveLinkToEmbed(videoUrl.value)}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
      <div>
        <Row className="mt10">
          <Col span={2}></Col>

          <Col span={20}>
            <h2 className="bold">{txtTitle.value} </h2>

            <div className="video-wrap-author mb10">
              <div className="video-author">
                <Avatar src={avatarUrl} size={"large"} className="video-comment-avatar">
                  {sender.value ? sender.value.charAt(0).toUpperCase() : ""}
                </Avatar>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="video-comment-header"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Text className="video-comment-author" strong>
                      {sender.value}
                    </Text>
                  </div>
                  <div style={{ fontSize: 12, color: "gray" }}>
                    {updateTime}
                  </div>
                </div>
              </div>
              <div className="video-options">
                <Popover
                  overlayClassName="video-popover"
                  content={
                    <VideoAction
                      isEdit={isEdit}
                      isDelete={isDelete}
                      videoId={id}
                      isVideoPlayList={isVideoPlayList}
                      callBackAddPlayList={() => setisVideoPlayList(true)}
                    />
                  }
                  trigger="click"
                  placement="bottomLeft"
                >
                  <EllipsisOutlined />{" "}
                </Popover>
              </div>
            </div>

            <VideoDescription
              categoryName={listCate.label}
              tags={tags}
              offices={selectedOffice}
              description={txtDescription.value}
              listMachine={listMachine}
            />
            <VideoComments setIsDirty={setIsDirty} />
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
    {!isHideButtonBack &&   <FooterPage>
        <Row justify="end">
          <Button
            className="buttonPC button--outline wAuto ml10"
            onClick={handleback}
          >
            <RollbackOutlined /> {lang.BACK}
          </Button>
        </Row>
      </FooterPage>}
      <Loading show={showLoading}></Loading>
    </div>
  );
}

export default ViewVideo;
